import React, { Component } from 'react';
import { connect } from "react-redux";
import { compose } from "redux";
import { change } from 'redux-form';

import { TAB_OCCUPATIONS, TAB_ROOMS } from "../constants";
import { setArrival } from "../store/actions";

import DepartureArrival from './DepartureArrival';
import Occupancies from "./Occupancies";
import Rooms from './Rooms';

class Step1 extends Component {
	availabilitiesFromDate = null;

	constructor(props) {
		super(props);

		this.state = {
			tab: TAB_ROOMS,
		};
	}

	onTabChange = (tab) => {
		this.setState({ tab: tab });
	};

	handleRoomTypeAvailabilityClick = (roomType, date) => {
		// změníme datum příjezdu
		this.props.dispatch(setArrival(date, (store) => {
			// a přednastavíme vybraný typ pokoje
			const roomOffer = store.app.roomOffers.find(roomOffer => roomOffer.id === parseInt(roomType, 10));
			if (roomOffer && store.app.noOfNights >= roomOffer.minNights) {
				const room = {...roomOffer, guestTypes: {}};
				Object.values(store.app.guestTypes).forEach(guestType => room.guestTypes[guestType.id] = guestType.default ? 1 : 0);
				this.props.dispatch(change('bookingForm', 'rooms[' + roomType + '][0]', room));
			}

			this.setState({ tab: TAB_ROOMS });
		}));
	};

	render() {
		return (
            <div className="container">

				<DepartureArrival onTabChange={this.onTabChange} tab={this.state.tab} />

				{this.state.tab === TAB_OCCUPATIONS &&
				<Occupancies
					fromDate={this.availabilitiesFromDate}
					onFromDateChange={date => this.availabilitiesFromDate = date}
					onRoomTypeAvailabilityClick={(roomType, date) => this.handleRoomTypeAvailabilityClick(roomType, date)}
				/>
				}

				{this.state.tab === TAB_ROOMS &&
				<Rooms/>
				}

            </div>
		);
	}
}

export default compose(
	connect((state) => ({
	})),
)(Step1);



// WEBPACK FOOTER //
// ./src/components/Step1.jsx